import React from 'react'

import {
  ProfileButton,
  ProfileMenuBlock,
  ProfileTitle,
} from './ProfileComponents.tsx'
import { FormattedMessage } from 'react-intl'
import {
  SUPPORT_MAX_URL,
  SUPPORT_TELEGRAM_URL,
} from '../../shared/constants.ts'

const contacts = [
  {
    title: 'Telegram',
    img: '/images/contacts/telegram.svg',
    url: SUPPORT_TELEGRAM_URL,
    urlTitle: '@uni_ai_ed',
  },
  {
    title: 'MAX',
    img: '/images/contacts/max.svg',
    url: SUPPORT_MAX_URL,
    urlTitle: 'max.ru',
  },
  //   {
  //     title: 'Whatsapp',
  //     img: '/images/contacts/whatsapp.svg',
  //     url: 'https://wa.me/message/4DA7WT5FGXIRE1',
  //     urlTitle: 'Edman Ai',
  //   },
  //   {
  //     title: 'E-mail',
  //     img: '/images/contacts/email.svg',
  //     url: 'mailto:support@edman.ai',
  //     urlTitle: 'support@edman.ai',
  //   },
]

export const ProfileSupport = () => {
  return (
    <div>
      <ProfileTitle
        title={<FormattedMessage id="user.support" />}
      />
      <div className="flex flex-col gap-16">
        {contacts.map((x, i) => {
          return (
            <ProfileMenuBlock key={i}>
              <ProfileButton
                withArrow
                imageUrl={x.img}
                onClick={() => {
                  window.open(x.url, '_blank')
                }}
                title={x.title}
                subtitle={x.urlTitle}
              />
            </ProfileMenuBlock>
          )
        })}
      </div>
    </div>
  )
}
